import Vue from 'vue'
import baseLayout from '@/components/base-layout'
import svgIcon from '@/components/svg-icon'
import snackbar from '@/components/snackbar'

Vue.component('base-layout', baseLayout)
Vue.component('svg-icon', svgIcon)
Vue.component('snackbar', snackbar)
